export default {
  Nameofcontactperson: '请输入联系人姓名',
  return: '返回',
  submit: '提交',
  female: '女',
  male: '男',
  IDnumber: '身份证号',
  sex: '性别',
  excel: 'EXCEL 导入',
  excelTip: '可以通过Excel导入施工人员资料',
  applyPass: '施工人员通行证申请',
  add: '新增申请',
  listPass: '施工人员通行证申请列表',
  workerNumber: '施工人员数量',
  viewDetails: '查看详情',
  ExhibitionName: '展会名称',
  detail: '施工人员通行证申请详情',
  revise: '修改',
  hold: '保存',
  Return: '返回',
  companyName: '搭建商公司名称',
  number: '数量',
  ensureNumberTips: '请确保施工人员的数量',
  information: '施工人员信息',
  tip_1: '本页面无法修改施工证申请，如有所需点击',
  tip_2: '施工证申请',
  tip_3: '进行修改',
  '提示': '提示',
  '是否确认提交': '是否确认提交',
  '操作成功': '操作成功',
  '请输入联系人姓名': '请输入联系人姓名',
  '请输入电话号码': '请输入电话号码',
  '请输入身份证号': '请输入身份证号',
  '如有特殊情况请说明': '如有特殊情况请说明',
  '请输入正确的联系方式': '请输入正确的联系方式',
  '请输入正确的身份证号': '请输入正确的身份证号',
  '上一步': '上一步',
  '下一步': '下一步',
  '男': '男',
  '女': '女',
  '新增人员': '新增人员',
  '每次最多只能导入50条施工证人员信息': '每次最多只能导入50条施工证人员信息',
  '搭建商': '搭建商',

  "施工证申请": "施工证申请",
  "申请须知": "申请须知",
  "已知悉": "已知悉",
  "新增申请": "新增申请",
  "暂无数据": "暂无数据",
  "申请编号": "申请编号",
  "搭建商公司": "搭建商公司",
  "施工展位": "施工展位",
  "证件数量": "证件数量",
  "状态": "状态",
  "查看申请": "查看申请",
  "继续填写": "继续填写",
  "修改资料": "修改资料",
  "取消申请": "取消申请",
  "资料填写": "资料填写",
  "搭建公司名称": "搭建公司名称",
  "请输入搭建商公司名称": "请输入搭建商公司名称",
  "请输入搭建商公司名称（可检索）": "请输入搭建商公司名称（可检索）",
  "添加展位": "添加展位",
  "证件数量": "证件数量",
  "人员信息": "人员信息",
  "批量导入": "批量导入",
  "可通过": "可通过",
  "可通过Excel批量导入人员信息": "可通过Excel批量导入人员信息",
  "填写施工人员信息，批量导入人员信息":"填写施工人员信息，批量导入人员信息",
  "点击下载导入表格模板": "点击下载导入表格模板",
  "请勿导入超过30条数据，若人员较多，可另外新增申请": "请勿导入超过30条数据，若人员较多，可另外新增申请",
  "姓名": "姓名",
  "性别": "性别",
  "序号": "序号",
  "身份证号码": "身份证号码",
  "联系电话": "联系电话",
  "图片": "图片",
  "操作": "操作",
  "审核意见": "审核意见",
  "添加人员": "添加人员",
  "保存并提交": "保存并提交",
  "保存草稿": "保存草稿",
  "返回": "返回",
  "上传图片": "上传图片",
  "删除": "删除",
  "确定": "确定",
  "取消": "取消",
  "请输入展位号": "请输入展位号",
  "请输入姓名": "请输入姓名",
  "请输入身份证号码": "请输入身份证号码",
  "请输入正确的身份证号码": "请输入正确的身份证号码",
  "请输入电话": "请输入电话",
  "请输入正确的联系电话": "请输入正确的联系电话",
  "是否删除该项": "是否删除该项",
  "无此展位": "无此展位",
  "请上传": "请上传",
  "张": "张",
  "图片数量不足": "图片数量不足",
  "您的施工证申请审核未通过": "您的施工证申请审核未通过",
  "必填项未填写，请检查": "必填项未填写，请检查",
  "姓名必填": "姓名必填",
  "身份证格式有误": "身份证格式有误",
  "身份证信息必填": "身份证信息必填",
  "手机号码格式有误": "手机号码格式有误",
  "手机号码必填": "手机号码必填",
  "第": "第",
  "行": "行",

}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/constructionPermit.js